import React, { useState } from 'react';
import { Dialog, Slide, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const BaseDialog = ({isOpen, handleClose, title, children}) => {


  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        TransitionComponent={Slide}
        TransitionProps={{ direction: 'up' }}
        sx={{
            '& .MuiPaper-root': {
                position: 'fixed',
                bottom: 0,
                width: '100%',
                margin: 0,
                borderRadius: '16px 16px 0 0',
                overflow: 'hidden',
            },
        }}
      >
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                padding: 2,
                backgroundColor: 'background.paper',
            }}
        >
            <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: '100%' }}
            >
                <IconButton
                    onClick={handleClose}
                    sx={{
                        display: 'flex',
                        fontSize: 18,
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '10%'
                    }}
                >
                    <CloseIcon/>
                </IconButton>
                <Typography
                    variant='caption'
                    sx={{
                        flexGrow: 1,
                        textAlign: 'center'
                    }}
                >
                    {title}
                </Typography>
                <Box
                    sx={{
                        width: '10%'
                    }}
                >

                </Box>
            </Box>
            {children}
        </Box>
      </Dialog>
    </div>
  );
};

export default BaseDialog;
